<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>队伍管理</el-breadcrumb-item>

    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="float: right;margin-right:2%;display: flex;align-items: center;">
      
      <span
        style="background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
        可提现余额总计(元)：{{ sumTeamMoney }}
      </span>
      <span
        style="margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
        已删除队伍余额总计(元)：{{ sumDeteltTeamMoney || 0 }}
        <!-- <el-button size="mini" type="danger" @click="updateAllTeamFeeTo()">修改</el-button> -->
      </span>
      <span
        style="margin: 8px;background-color: rgb(66, 185, 131); color: rgb(255, 255, 255); border-radius: 8px;display: block;padding: 8px 20px;">
        已禁用队伍余额总计(元)：{{ sumState2TeamMoney || 0 }}
        <!-- <el-button size="mini" type="danger" @click="updateAllTeamFeeTo()">修改</el-button> -->
      </span>
      

      <input placeholder="输入网点名称的关键字进行搜索" v-model="outlet" style='margin: 10px 0;'></input>
      <el-button style='margin: 10px;' size="mini" type="primary" icon="document" @click="dataSelect">搜索</el-button>
    </div>

    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column align="center" prop="outlet" label="网点名称">
      </el-table-column>
      <el-table-column align="center" prop="business" label="业务名称">
      </el-table-column>
      <el-table-column align="center" prop="phone" label="联系电话">
      </el-table-column>
      <el-table-column align="center" prop="img" label="队伍创建者头像">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.img"
            :preview-src-list="[scope.row.img]"></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="money" label="可提现金额">
      </el-table-column>
      <el-table-column align="center" prop="nickName" label="队伍创建者名称">
      </el-table-column>

      <el-table-column width="500" align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="teamAdmin(scope.row.id)">分配管理员</el-button>
          <el-button v-if="scope.row.isPayout == true" size="mini" type="danger"
            @click="updateTeamPayoutTo(scope.row.id, false)">关闭提现功能</el-button>
          <el-button v-if="scope.row.isPayout == false" size="mini" type="primary"
            @click="updateTeamPayoutTo(scope.row.id, true)">开启提现功能</el-button>
          <el-button size="mini" type="primary" @click="premiumList(scope.row.id)">提现金额、手续费统计</el-button>
          <el-button v-if="scope.row.state == false" size="mini" type="danger"
            @click="updateTeamStateTo(scope.row.id, true)">禁用</el-button>
          <el-button v-if="scope.row.state == true" size="mini" type="primary"
            @click="updateTeamStateTo(scope.row.id, false)">启用</el-button>
          <el-button size="mini" type="danger" @click="deleteTeams(scope.row.id)">删除</el-button>

          <el-button size="mini" type="danger" @click="openDialogFormVisible2(scope.row.id)">转送管理员</el-button>
          
        </template>
      </el-table-column>

      <el-table-column width="200" align="center" label="	取号最大金额上限(整数，未设置为默认值)">
        <template slot-scope="scope">
          <el-input style="width: 100px;" v-model="scope.row.maxNumMoney" placeholder="未设置"></el-input>
          <el-button type="success" @click="updateTeamMaxNumMoneyTo(scope.row.id, scope.row.maxNumMoney)">保存</el-button>
        </template>
      </el-table-column>

    </el-table>
    <div style="text-align: center;margin-top: 10px;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]" :page-size="size" :current-page="page" layout="total,sizes, prev, pager, next"
        :total="totalnum">
      </el-pagination>
    </div>

    <el-dialog title="队伍管理员列表" customClass="customWidth" :visible.sync="dialogFormVisible2" center>
				<!-- <div style="position: relative;display: inline-block;float: right;">
					<el-input style="width: 200px;" @keydown.enter.native="dataSelect2" placeholder="搜索管理员名称"
						v-model="name">
					</el-input>
					<span @click="dataSelect2" style="position: absolute;right: 0;top:8px;">
						<icon-svg name="shousuo" class="site-sidebar__menu-icon"></icon-svg>
					</span>
				</div> -->
				<el-table v-loading="tableDataLoading2" height="450" :data="getTeamAdminList">
					<el-table-column fixed prop="id" label="编号" width="80">
					</el-table-column>
					<el-table-column fixed prop="img" label="用户头像">
						<template slot-scope="scope">
							<img :src="scope.row.img" alt="" width="60" height="60">
						</template>
					</el-table-column>
					<el-table-column prop="name" label="管理员名称" width="160">
					</el-table-column>
					
					<!-- <el-table-column prop="createAt" label="创建时间" width="160">
					</el-table-column> -->
					<el-table-column fixed="right" label="操作" prop="id">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="zRDW(scope.row.id)">转让队伍
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: center;margin-top: 10px;">
					<el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
						:page-sizes="[10, 20, 30, 50, 100]" :page-size="size2" :current-page="page2"
						layout="total,sizes, prev, pager, next" :total="totalnum2">
					</el-pagination>
				</div>
			</el-dialog>

  </div>
</template>

<script>

import { getAdminTeamList, updateTeamState, updateTeamPayout, updateTeamMaxNumMoney, deleteTeams, getTeamAdminLists , transferTeamAdmins } from '../../../api/manage/team.js'

import moment from 'moment';

export default {
  data() {
    return {
      dialogFormVisible2:false,
      teamId:0,
      totalnum2: 0,
      page2: 1,
      size2: 10,
      getTeamAdminList:[],
      name:'',
      sumState2TeamMoney:'',
      sumDeteltTeamMoney: '',
      sumTeamMoney: '',
      outlet: '',
      startDate: '',
      endDate: '',
      dateTime: '',
      outlet: '',
      multipleSelection: [],
      totalnum: 0,
      page: 1,
      size: 10,
      tableDataLoading: false,
      tableDataLoading2: false,
      dialogFormVisible5: false,
      dialogFormVisible: false,
      tableData: [],
      updateForm: {

      },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    
    zRDW(id){
      // transferTeamAdmins
      let post = {
        id: id,
      }
			transferTeamAdmins(post).then((res) => {
        this.dialogFormVisible2 = false
        // console.log("res=============",res)
        // this.getTeamAdminList=res.data.list
        // this.totalnum2 = res.data.count
        this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
      })
    },

    openDialogFormVisible2(row) {
			this.dialogFormVisible2 = true
      this.teamId=row;
			// if(reasonStatus==1){
			// this.title = ""
			// }
      let post = {
        teamId: this.teamId,
      }
			getTeamAdminLists(post).then((res) => {
        // this.dialogFormVisible2 = false
        console.log("res=============",res)
        this.getTeamAdminList=res.data.list
        this.totalnum2 = res.data.count
       
      })
		},
    dataSelect2(){
      let post = {
        teamId: this.teamId,
      }
      getTeamAdminLists(post).then((res) => {
        // this.dialogFormVisible2 = false
        console.log("res=============",res)
        this.getTeamAdminList=res.data.list
        this.totalnum2 = res.data.count
      })

    },

    handleSizeChange2(val) {
      this.size2 = val;
      this.dataSelect2()
    },
    handleCurrentChange2(val) {
      this.page2 = val;
      this.dataSelect2()
    },


    handleSizeChange(val) {
      this.size = val;
      this.dataSelect()
    },
    handleCurrentChange(val) {
      this.page = val;
      this.dataSelect()
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    isPositiveInteger(str) {
      const regex = /^\d+$/;
      return regex.test(str);
    },

    teamAdmin(id) {
      this.$router.push({ path: 'admin', query: { teamId: id } });
    },

    premiumList(id) {
      // this.$router.push({ path: 'premiumList', params: { teamId: id } });
      this.$router.push({ path: 'premiumList', query: { teamId: id } });
      // window.location.pathname = "/premiumList?teamId="+teamId
    },

    updateTeamMaxNumMoneyTo(teamId, maxNumMoney) {
      if (this.isPositiveInteger(maxNumMoney)) {
        let post = {
          teamId: teamId,
          maxNumMoney: maxNumMoney,
        }
        updateTeamMaxNumMoney(post).then((res) => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      } else {
        this.$message({
          type: "success",
          message: "只能设置为正整数",
          duration: 1500,

        });
      }

    },


    deleteTeams(teamId) {
      let post = {
        id: teamId,
      }
      this.$confirm(`确认要删除该队伍吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteTeams(post).then((res) => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => { })

    },


    updateTeamPayoutTo(teamId, payout) {
      let post = {
        teamId: teamId,
        payout: payout,
      }
      this.$confirm(`确认更变该队伍提现功能吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateTeamPayout(post).then((res) => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => { })

    },

    updateTeamStateTo(teamId, state) {
      let post = {
        teamId: teamId,
        state: state,
      }
      this.$confirm(`确认更变该队伍状态吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateTeamState(post).then((res) => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => { })

    },

    dataSelect() {
      let post = {
        page: (this.page - 1) * this.size,
        size: this.size,
        outlet: this.outlet

      }
      this.tableDataLoading = true
      getAdminTeamList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
          this.tableData = res.data.list
          this.sumDeteltTeamMoney = res.data.sumDeteltTeamMoney
          this.sumState2TeamMoney = res.data.sumState2TeamMoney
          this.sumTeamMoney = res.data.sumTeamMoney
          this.totalnum = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })

    },

  }
}
</script>

<style >
.userRole {
  width: 100%;

}

.customWidth {
  width: 80% !important;
}

</style>


// WEBPACK FOOTER //
// src/views/manage/team/index.vue